import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { BASE_URL } from '../../core/global/constants';
import { UserService } from '../../core/services/user.service';
import { ExecutionResult } from '../models/common';

@Injectable({
    providedIn: 'root'
})
export class LogoutService {
    private baseUrlProvider = inject<Promise<string>>(BASE_URL);
    private http = inject(HttpClient);
    private userService = inject(UserService);

    logout() {
        const user = this.userService.getUser() || {};

        return from(this.baseUrlProvider).pipe(
            switchMap(baseUrl =>
                this.http.post(baseUrl + 'TerminateUserSession', {
                    usr: user,
                    usrToLogOut: {
                        EntityId: user.EntityId,
                        EntityTypeId: user.EntityTypeId,
                    },
                }) as Observable<ExecutionResult>
            )
        );
    }
}
